import { Spin } from "antd";
import { FormProvider } from "react-hook-form";

import { AdminMenuLayout, ModalProductWarehouses } from "../../../shared/components";
import { useProductById, useProducts } from "../hooks";
import { ProductsForm } from "./productById";
import { WrapperProductById } from "./styled";
import React from "react";

export const ProductsById = () => {
  const { isUpdateProduct, formMethodsCreate, formMethodsUpdate } =
    useProducts();
  const { isValidate } = useProductById();
  const [openModalAsignedProduct, setOpenModalAsignedProduct] =
    React.useState(false);

  return (
    <AdminMenuLayout pageDescription="ProductsById" title="ProductsById">
      <WrapperProductById>
        {!isValidate ? (
          <Spin size="large" />
        ) : (
          <FormProvider
            {...(isUpdateProduct ? formMethodsUpdate : formMethodsCreate)}
          >
            <ProductsForm
              onAssignWarehouse={() => setOpenModalAsignedProduct(true)}
            />
          </FormProvider>
        )}
        <ModalProductWarehouses
          openModal={openModalAsignedProduct}
          setOpenModal={setOpenModalAsignedProduct}
        />
      </WrapperProductById>
    </AdminMenuLayout>
  );
};
